export const RECEIVE_TOUCH_GROUPS = 'RECEIVE_TOUCH_GROUPS';

export const receiveTouchGroups = response => ({
    type: RECEIVE_TOUCH_GROUPS,
    payload: response,
});
